import { render } from "./CommonShowMore.vue?vue&type=template&id=225a2174"
import script from "./CommonShowMore.vue?vue&type=script&lang=js"
export * from "./CommonShowMore.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildagent/work/d91510003b19d3df/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__